export enum IrisContentViewType {
  Tile = 'tile',
  List = 'list',
}
